module.exports = __webpack_public_path__ + "static/media/ITC-OfficinaSansITCPro-Book.b34c75a9.otf";